import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import plugin menu
import * as pm from '../../menus/index';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../shared.module';

@NgModule({
  imports: [TranslateModule, CommonModule, SharedModule],
  declarations: [
    pm.EditFileMenuComponent,
    pm.ObservationMenuComponent,
    pm.EditObservationMenuComponent,
    pm.EditDiscussionMenuComponent,
    pm.EditFileAndSuggestionMenuComponent,
    pm.FileManagerMenuComponent,
    pm.FileReaderMenuComponent,
    //installation menus
    pm.InstallationCustomerAttendeesMenuComponent,
    pm.InstallationSignatureMenuComponent,
    pm.UpgradesMenuComponent
  ],
  providers: [],
  exports: []
})
export class PluginMenuModule {}
